"use strict";var scrollKeyPreventer = require('makeup-prevent-scroll-keys');
var rovingTabindex = require('makeup-roving-tabindex');
var typeahead = require('makeup-typeahead').default;
var eventUtils = require('../../common/event-utils');
var menuUtils = require('../../common/menu-utils');

var TYPEAHEAD_TIMEOUT_LENGTH = 1300;

module.exports = Object.assign({}, menuUtils, {
  toggleItemChecked(index, originalEvent, itemEl) {
    // This needs to be at start since toggleChecked swaps the checkedIndex
    // and then the right events will not fire correctly
    var shouldEmitRadio = this.isRadio() && index !== this.state.checkedIndex;
    this.toggleChecked(index);

    if (shouldEmitRadio) {
      this.emitComponentEvent({
        index,
        eventType: 'change',
        el: itemEl,
        originalEvent });

    } else if (this.type !== 'radio') {
      this.emitComponentEvent({
        index,
        eventType: !this.type ? 'select' : 'change',
        el: itemEl,
        originalEvent });

    }

    if (this.rovingTabindex) {
      this.tabindexPosition = this.rovingTabindex.filteredItems.findIndex(
      function (el) {return el.tabIndex === 0;});

    }
  },

  handleItemClick(index, originalEvent, itemEl) {
    this.toggleItemChecked(index, originalEvent, itemEl);
  },

  handleItemKeydown(index, originalEvent, itemEl) {var _this = this;
    eventUtils.handleEscapeKeydown(originalEvent, function () {
      _this.emitComponentEvent({ eventType: 'keydown', originalEvent, index });
    });

    eventUtils.handleActionKeydown(originalEvent, function () {return (
        _this.toggleItemChecked(index, originalEvent, itemEl));});

  },

  handleItemKeypress(_ref) {var key = _ref.key;
    var itemIndex = this.getTypeaheadIndex(
    this.getEl('menu').children,
    key,
    this.input.typeaheadTimeoutLength || TYPEAHEAD_TIMEOUT_LENGTH);


    if (itemIndex !== -1) {
      this.tabindexPosition = this.rovingTabindex.index = itemIndex;
    }
  },

  emitComponentEvent(_ref2) {var eventType = _ref2.eventType,el = _ref2.el,originalEvent = _ref2.originalEvent,index = _ref2.index;
    var checkedIndexes = this.getCheckedIndexes();
    var isCheckbox = this.type === 'checkbox';

    var eventObj = {
      el,
      originalEvent };


    if (isCheckbox && checkedIndexes.length > 1) {
      Object.assign(eventObj, {
        index,
        indexes: this.getCheckedIndexes(), // DEPRECATED in v5
        checked: this.getCheckedIndexes(), // DEPRECATED in v5 (keep but change from indexes to values)
        checkedValues: this.getCheckedValues() // DEPRECATED in v5
      });
    } else if (isCheckbox || this.isRadio()) {
      Object.assign(eventObj, {
        index, // DEPRECATED in v5
        checked: this.getCheckedIndexes(), // DEPRECATED in v5 (keep but change from indexes to values)
        checkedValues: this.getCheckedValues() // DEPRECATED in v5
      });
    } else {
      Object.assign(eventObj, {
        index, // DEPRECATED in v5
        checked: [index] // DEPRECATED in v5 (keep but change from indexes to values)
      });
    }

    this.emit("" + eventType, eventObj);
  },

  onInput(input) {
    this.state = this.getInputState(input);
  },

  onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  },

  onMount() {
    this.tabindexPosition = 0;
    this._setupMakeup();
  },

  onUpdate() {
    this._setupMakeup();
  },

  onDestroy() {
    this._cleanupMakeup();
  },

  _setupMakeup() {
    this.contentEl = this.getEl('menu');

    this.rovingTabindex = rovingTabindex.createLinear(this.contentEl, 'div', {
      index: this.tabindexPosition,
      autoReset: null });


    scrollKeyPreventer.add(this.contentEl);

    var _typeahead = typeahead(),getTypeaheadIndex = _typeahead.getIndex,destroyTypeahead = _typeahead.destroy;
    this.getTypeaheadIndex = getTypeaheadIndex;
    this.destroyTypeahead = destroyTypeahead;
  },

  _cleanupMakeup() {
    if (this.rovingTabindex) {
      this.rovingTabindex.destroy();
      scrollKeyPreventer.remove(this.contentEl);
    }
    if (this.destroyTypeahead) {
      this.destroyTypeahead();
    }
  } });